class SortableTable extends DrupalBehavior {
  onContent(context) {

    let table;
    if ($('.sortable-table table.sortable-table--events:not(.dataTable)', context).length > 0) {

      let frozenValue = $('.frozen-row', context);
      var currentPagerPosition = 0;
      var hidden = '';
      var el = $('.sortable-table table.sortable-table--events:not(.dataTable)');
      var elWrapper = el.closest('section');
      var paging = elWrapper.attr('data-paging') == '1';
      if (typeof (frozenValue.data('frozen')) !== 'undefined') {
        let tr = $('.sortable-table--events:not(.dataTable)', context).find('tr:eq(' + frozenValue.data('frozen') + ')');

        var frozenValues = [];
        tr.find('td').each(function () {
          var tdValue = $(this).html().replace(/(<([^>]+)>)/gi, "").trim();

          var tempHidden = $.fn.dataTable.absoluteOrder([{
            value: $(this).html(),
            position: 'top'
          }]);

          var tempValue = {
            targets: $(this).index(),
            type: tempHidden
          }

          frozenValues.push(tempValue);
        })

        // console.log(frozenValues);
      }

      table = $('.sortable-table table', context).on('init.dt', function (e, settings, json) {
        $('.dataTables_filter input').attr('placeholder', 'Search');
        nakedFormSelect('.sortable-table .dataTables_length select', {
          context: {
            value: context
          },
          events: {
            open: openDropdown,
            close: closeDropdown
          }
        });
        enhanceDataTablesLengthA11y(context);
      }).DataTable({
        dom: '<fl<t>ip>',
        columnDefs: frozenValues,
        paging: paging,
        fnDrawCallback: function (o) {
          scrollOffsetTop(o._iDisplayStart);
        }
      });
    } else {
      var currentPagerPosition = 0;
      var el = $('.sortable-table table:not(.dataTable)', context);
      var elWrapper = el.closest('section');
      var paging = elWrapper.attr('data-paging') == '1';

      table = el.on('init.dt', function (e, settings, json) {
        $('.dataTables_filter input').attr('placeholder', 'Search');
        nakedFormSelect('.sortable-table .dataTables_length select', {
          context: {
            value: context
          },
          events: {
            open: openDropdown,
            close: closeDropdown
          }
        });
        enhanceDataTablesLengthA11y(context);
      }).DataTable({
        dom: '<fl<t>ip>',
        paging: paging,
        fnDrawCallback: function (o) {
          scrollOffsetTop(o._iDisplayStart);
        }
      });
    }

    table.on('draw.dt', function () {
      let dropdown = context.querySelector('.sortable-table .dataTables_length .naked-form-select-wrap.open');
      if (dropdown !== null) {
        dropdown.classList.remove('open');
        closeDropdown();
      }
    })

    function scrollOffsetTop(pagerPosition) {
      if (currentPagerPosition !== pagerPosition) {
        let target = $('.sortable-table', context);
        let targetOffset = target.offset().top - 15;
        $('html', context).animate({scrollTop: targetOffset}, 500);
        currentPagerPosition = pagerPosition
      }
    }

    function openDropdown() {
      gsap.to($('.sortable-table .dataTables_length .options-wrap', context), {
        duration: .4,
        ease: 'power4.out',
        height: 'auto'
      });
    }

    function closeDropdown() {
      gsap.to($('.sortable-table .dataTables_length .options-wrap', context), {
        duration: .4,
        ease: 'power4.out',
        height: 0
      });
    }

    function enhanceDataTablesLengthA11y(ctx) {
      if (typeof window.enhanceNakedFormSelectKeyboard !== 'function') return;
      ctx.querySelectorAll('.sortable-table .dataTables_length').forEach((lengthWrap) => {
        window.enhanceNakedFormSelectKeyboard(lengthWrap);
      });
    }
  }
}

DrupalBehavior.register('summit_theme', 'SortableTable', SortableTable);
